<span [class]="styleClass" (click)="openContactForm()" role="button">{{
  labelKey | translate
}}</span>
